import {Box, Checkbox, FormGroup, Link, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

import FormControlLabel from '@explorer/components/ui/filter-form-control-label';
import {IMAGERY_CAPABILITIES} from '@explorer/constants/asset-types';

const SpectralBandsFilter = ({selected, onChange, disabled}) => {
  const {t} = useTranslation();

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography component="span">
          {t('filters.groupLabelSpectralBands')}
        </Typography>

        <Link
          color="inherit"
          underline="always"
          variant="caption"
          href="https://docs.planet.com/data/imagery/planetscope/psscene/"
          target="_blank"
          rel="noreferrer noopener"
        >
          {t('filters.linkDocsPssceneSpectralBands')}
        </Link>
      </Box>
      <Typography variant="caption">
        {t('filters.groupDetailsSpectralBands')}
      </Typography>
      <FormGroup sx={{marginLeft: 0.5}}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              name={IMAGERY_CAPABILITIES.nir}
              checked={selected.includes(IMAGERY_CAPABILITIES.nir)}
              onChange={onChange}
            />
          }
          label={t('filters.fieldLabelNir')}
          disabled={disabled}
        />
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              name={IMAGERY_CAPABILITIES.multispectral}
              checked={selected.includes(IMAGERY_CAPABILITIES.multispectral)}
              onChange={onChange}
            />
          }
          label={t('filters.fieldLabelMultiBand')}
          disabled={disabled}
        />
      </FormGroup>
    </Box>
  );
};

SpectralBandsFilter.propTypes = {
  selected: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default SpectralBandsFilter;
